import { useList } from '@inmagik/react-crud'
import { API_URL } from '../constants'
import { Opportunita } from '../types'

export function useOpportunita(params: Record<string, string> = {}) {
  return useList<Opportunita>(`${API_URL}/bilance/opportunita`, params)
}
